/** 2026-07-21 00:00:00 前展示世界杯/旧版资源（底部 Lottie yule_1/tiyu_1、我的页头像框等） */
export const PROMO_ASSET_SWITCH_AT = new Date(2026, 6, 21).getTime();

export const isBeforePromoAssetSwitch = (): boolean => Date.now() < PROMO_ASSET_SWITCH_AT;
